var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leading-normal transition duration-300 ease-in font-display bg-quaternary",attrs:{"id":"app"}},[_c('Container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }